import React, {useMemo} from 'react';
import cn from 'classnames';

import ViewportMgr from 'coreClasses/view/ViewportMgr';

import {IShowOrHideOnBreakpointProps} from './IShowOrHideOnBreakpoint';

import styles from './ShowOrHideOnBreakpoint.module.scss';

const ShowOrHideOnBreakpoint = ({
	as: Tag = 'div',
	classNames,
	children,
	query,
	attachToChildren,
}: IShowOrHideOnBreakpointProps) => {

	const classes = useMemo(() => {
		if (!query) {
			return;
		}

		const [operator, operand] = ViewportMgr.parseQuery(query);

		const breakpoint = ViewportMgr.getBreakpointsExtendedMap()[operand];

		if (!breakpoint) {
			return;
		}

		return cn(
			classNames,
			{
				[styles[`show-on-${breakpoint}`]]: operator === '>',
				[styles[`hide-on-${breakpoint}`]]: operator === '<',
				[styles[`show-on-${breakpoint}-exclude`]]: operator === '>=',
				[styles[`hide-on-${breakpoint}-exclude`]]: operator === '<=',
			}
		);
	}, [query, classNames]);

	if (attachToChildren) {
		return React.Children.map(children, (child: React.ReactElement) => {
			let newProps = undefined;

			// Case on custom component with classNames prop
			newProps = {
				classNames: cn(child.props.classNames, classes),
				className: cn(child.props.className, classes),
			};

			return React.cloneElement(child, newProps);
		});
	}

	return (
		<Tag className={classes}>
			{children}
		</Tag>
	);
};

export default ShowOrHideOnBreakpoint;
